import { render, staticRenderFns } from "./Consulenza.vue?vue&type=template&id=311f4a77&"
import script from "./Consulenza.vue?vue&type=script&lang=js&"
export * from "./Consulenza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports